/**
 * The low stock message for a variant, or an empty string when none applies.
 * Shows once inventory reaches threshold + safety allowance; the displayed
 * count is inventory minus the allowance, held at a minimum of 1.
 *
 * @param {object} inventory { inventory_quantity, inventory_management }
 * @param {object} config { threshold, safetyAllowance, message }
 * @returns {string}
 */
export function lowStockMessage(inventory, { threshold, safetyAllowance, message }) {
  if (!inventory?.inventory_management) return "";

  const quantity = inventory.inventory_quantity;
  if (quantity <= 0 || quantity > threshold + safetyAllowance) return "";

  const count = Math.max(quantity - safetyAllowance, 1);

  return message.replaceAll("[X]", count);
}

class LowStockMessage extends HTMLElement {
  connectedCallback() {
    this.productForm = this.closest("product-form");

    this.handleVariantChange = (e) => this.render(e.detail.variant);

    this.productForm?.addEventListener(
      "variant:changed",
      this.handleVariantChange,
    );
  }

  disconnectedCallback() {
    this.productForm?.removeEventListener(
      "variant:changed",
      this.handleVariantChange,
    );
  }

  get config() {
    return {
      threshold: parseInt(this.getAttribute("threshold"), 10),
      safetyAllowance: parseInt(this.getAttribute("safety-allowance"), 10) || 0,
      message: this.getAttribute("message") || "",
    };
  }

  render(variant) {
    const data = window.scrapeSectionData(this.productForm);
    const inventory = variant
      ? data.optionsByVariant?.find((v) => v.variantId === variant.id)
      : null;

    this.textContent = lowStockMessage(inventory, this.config);
  }
}

if (!customElements.get("low-stock-message")) {
  customElements.define("low-stock-message", LowStockMessage);
}
